"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.3451 6.82123L12.0451 3.52124L11.1031 4.46657L13.9697 7.33323H4.58105V8.66656H13.9697L11.1031 11.5332L12.0457 12.4759L15.3457 9.1759C15.5005 9.02113 15.6233 8.83738 15.7071 8.63514C15.7909 8.4329 15.834 8.21614 15.834 7.99723C15.834 7.77833 15.7909 7.56156 15.7071 7.35933C15.6233 7.15709 15.5005 6.97334 15.3457 6.81857L15.3451 6.82123Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15392 14C7.15392 14.1768 7.08368 14.3464 6.95866 14.4714C6.83364 14.5964 6.66407 14.6667 6.48726 14.6667H2.16992C1.99311 14.6667 1.82354 14.5964 1.69852 14.4714C1.57349 14.3464 1.50326 14.1768 1.50326 14V2C1.50326 1.82319 1.57349 1.65362 1.69852 1.5286C1.82354 1.40357 1.99311 1.33333 2.16992 1.33333H6.48726C6.66407 1.33333 6.83364 1.40357 6.95866 1.5286C7.08368 1.65362 7.15392 1.82319 7.15392 2V5.55533H8.48726V2C8.48726 1.46957 8.27654 0.960859 7.90147 0.585786C7.5264 0.210714 7.01769 0 6.48726 0L2.16992 0C1.63949 0 1.13078 0.210714 0.755708 0.585786C0.380636 0.960859 0.169922 1.46957 0.169922 2L0.169922 14C0.169922 14.5304 0.380636 15.0391 0.755708 15.4142C1.13078 15.7893 1.63949 16 2.16992 16H6.48726C7.01769 16 7.5264 15.7893 7.90147 15.4142C8.27654 15.0391 8.48726 14.5304 8.48726 14V10.4447H7.15392V14Z",
    fill: fill
  }));
};

exports["default"] = _default;